module.exports = __webpack_public_path__ + "img/54_43.7e2f4a47.png";